import type { SATAssessmentAttributes, SATTestInterventionArmAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import AssessmentQ from './AssessmentQ'
import {
  type AssociationDefinitions,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryOrderToSQL,
} from './common'
import SATTestQ from './SATTestQ'

const SATAssessmentQ = {
  ...makeQueryModelV2<SATAssessmentAttributes>('sat_assessment')([
    'id',
    'created_at',
    'assessment_id',
    'sat_test_id',
    'answers_pdf_url',
    'test_pdf_url',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    Assessment: {
      query: AssessmentQ,
      foreignKey: AssessmentQ.id,
      sourceKey: SATAssessmentQ.assessment_id,
    },
    SATTest: {
      query: SATTestQ,
      foreignKey: SATTestQ.id,
      sourceKey: SATAssessmentQ.sat_test_id,
    },
  }),

  where: (
    {
      id = null,
      assessmentId = null,
      satTestId = null,
      paranoid = true,
      include = [],
      order = null,
    }: {
      id?: number | null | SQLFragment<number>
      assessmentId?: number | null | SQLFragment<number>
      satTestId?: number | SQLFragment<number> | null
      paranoid?: boolean
      include?: IncludeAssociations
      order?: QueryOrder | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<SATTestInterventionArmAttributes> => SQL`
        FROM ${SATAssessmentQ}
        ${includeAssociationsToSql(SATAssessmentQ, include)}
        WHERE
            ${id != null ? SQL`${SATAssessmentQ.id} = ${id} AND` : SQL``}
            ${
              assessmentId != null
                ? SQL`${SATAssessmentQ.assessment_id} = ${assessmentId} AND`
                : SQL``
            }
            ${satTestId != null ? SQL`${SATAssessmentQ.sat_test_id} = ${satTestId} AND` : SQL``}
            ${paranoid ? SQL`${SATAssessmentQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryOrderToSQL(order)}
    `,
}

export default SATAssessmentQ
